import React from "react";
import styles from "./Container.module.scss";
import clsx from "clsx";
import { BackIcon } from "../../icons/BackIcon";

export const BackButton = ({ onDismiss, inlineContent }) => (
  <div
    data-testid="BackButton"
    className={clsx("pd-b-m", styles.back, inlineContent && styles.withInlineContent)}
    onClick={onDismiss}
  >
    <BackIcon />
    {inlineContent}
  </div>
);

export const Container = ({
  onDismiss,
  dataTestId,
  className,
  withCard,
  children,
  inlineBackButtonContent,
}) => {
  return (
    <div
      className={clsx("container-fluid", styles.container, withCard && styles.withCard, className)}
      data-testid={dataTestId}
    >
      {onDismiss ? (
        <BackButton onDismiss={onDismiss} inlineContent={inlineBackButtonContent} />
      ) : null}
      {children}
    </div>
  );
};

export default Container;
